import { RouteNamesType } from 'src/modules/core/types/routes.types'

export const reminderEditRoute: string = '/reminder/edit'

export const routeNames: RouteNamesType = {
  dashboardPrefix: {
    path: '/dashboard',
    relative: 'dashboard/*',
  },
  dashboard: {
    path: '/dashboard/home',
    relative: 'home',
  },
  login: {
    path: '/onboarding/login',
    relative: 'login',
  },
  connectedAppAuthorize: {
    path: '/onboarding/connected-app-authorize',
    relative: 'connected-app-authorize',
  },
  loginWithToken: {
    path: '/onboarding/login-with-token',
    relative: 'login-with-token',
  },
  impersonate: {
    path: '/onboarding/impersonate',
    relative: 'impersonate',
  },
  // Never named "impersonate": this path flashes in the merchant's own address
  // bar, and it is a merchant logging into their own account.
  connectedAppLogin: {
    path: '/onboarding/connected-app-login',
    relative: 'connected-app-login',
  },
  forceLogout: {
    path: '/onboarding/force-logout',
    relative: 'force-logout',
  },
  settings: {
    path: '/dashboard/settings',
    relative: 'settings',
  },
  onboarding: {
    path: '/onboarding',
    relative: 'onboarding/*',
  },
  home: {
    path: '/',
    relative: '*',
  },
  configuration: {
    path: '/onboarding/configuration',
    relative: 'configuration',
  },
  bookingOnboarding: {
    path: '/onboarding/booking-onboarding',
    relative: 'booking-onboarding',
  },
  syncCalendar: {
    path: '/onboarding/sync-calendar',
    relative: 'sync-calendar',
  },
  terms: {
    path: '/terms',
    relative: 'terms',
  },
  privacy: {
    path: '/privacy',
    relative: 'privacy',
  },
  confirmation: {
    path: '/confirmation',
    relative: 'confirmation/:urlCode',
  },
  meet: {
    path: '/meet',
    relative: 'meet/:code',
  },
  booking: {
    path: '/book',
    relative: 'book/:providerId/:slug',
  },
  bookingConfirmed: {
    path: '/booking',
    relative: 'booking/:providerId/:slug/:bookingId',
  },
  bookingDetails: {
    path: '/bookings/:bookingId',
    relative: 'bookings/:bookingId',
  },
  reschedule: {
    path: '/reschedule/:urlCode',
    relative: 'reschedule/:urlCode',
  },
  bookingReschedule: {
    path: '/bookings/:bookingId/reschedule',
    relative: 'bookings/:bookingId/reschedule',
  },
  appointmentManage: {
    path: '/appointments/:bookingId',
    relative: 'appointments/:bookingId',
  },
  cancelPlan: {
    path: '/subscription/cancel',
    relative: 'subscription/cancel',
  },
  canceledSubscription: {
    path: '/subscription/canceled',
    relative: 'subscription/canceled',
  },
  pausedSubscription: {
    path: '/subscription/paused',
    relative: 'subscription/paused',
  },
  betaUsersSubscription: {
    path: '/subscription/beta',
    relative: 'subscription/beta',
  },
  subscriptionPlans: {
    path: '/subscription/plans',
    relative: 'subscription/plans',
  },
  support: {
    path: '/support',
    relative: 'support',
  },
  availabilitySettings: {
    path: '/dashboard/availability-settings',
    relative: 'availability-settings',
  },
  lateCancels: {
    path: '/dashboard/late-cancels',
    relative: 'late-cancels',
  },
}
